import type {
  MealDiaryConfig,
  MealDiaryDayData,
  WidgetConfig,
  WidgetWeekEntry,
} from "@/lib/schema";
import { countPhrase, sumOverDays } from "@/widgets/describe";
import { getWidgetModule } from "@/widgets/registry";
import type { DayWidgetModule } from "@/widgets/types";
import { DayView } from "./DayView";
import { SettingsEditor } from "./SettingsEditor";
import { maxScoreWeek, scoreDay, scoreWeek } from "./scoring";
import { validate } from "./validate";

function defaults(existing: WidgetConfig[]): MealDiaryConfig {
  const dayWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "day",
  );
  const maxRow = dayWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "meal-diary",
    label: "Måltider",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    points: 1,
    weekGoal: 7,
  };
}

// The meals live globally and survive the widget (docs/adr/0028); what the
// week loses is only its Måltider ferdig markers, and with them the points.
function describeWeekData(entry: WidgetWeekEntry): string | null {
  const days = sumOverDays<MealDiaryDayData>(entry, (day) =>
    day?.finished === true ? 1 : 0,
  );
  return countPhrase(days, "ferdig dag", "ferdige dager");
}

export const mealDiary: DayWidgetModule<MealDiaryConfig> = {
  kind: "meal-diary",
  label: "Måltider",
  scope: "day",
  scoring: "points",
  defaults,
  validate,
  SettingsEditor,
  DayView,
  describeWeekData,
  scoreDay,
  scoreWeek,
  maxScoreWeek,
};
